module.exports = __webpack_public_path__ + "img/img-intro-app-1-tw.e693f8c6.svg";